module.exports = __webpack_public_path__ + "static/img/man-icon.a55acdd4.svg";